import request from './request';

const notificationSummariesService = {
  getAll: (params = {}) =>
    request.get('dashboard/admin/notification-summaries', {
      params,
    }),
  getById: (id) => request.get(`dashboard/admin/notification-summaries/${id}`),
};

export default notificationSummariesService;
